<template>
  <div class="service_values_list">
    <div
        v-if="!inline"
        :class="['service_values_item', 'pvr_service', {disabled: !serviceData.pvr_free_minutes && !serviceData.pvr_lifetime_in_days}, {forbidden: serviceData.pvr_disabled_by_service}]">
      <span class="service_values_item_value">{{ serviceData.pvr_disabled_by_service ? $gettext('Zakázáno') : getDaysText(serviceData.pvr_lifetime_in_days) }}</span>
      <span id="pvr_service_help_popup" class="help_popup" style="display: none;" v-translate>
														Expirace nahrávek
													</span>
    </div>
    <div
        v-if="inline && (serviceData.pvr_free_minutes || serviceData.pvr_lifetime_in_days || serviceData.pvr_disabled_by_service)"
        :class="['service_values_item', 'pvr_service', {'disabled forbidden': serviceData.pvr_disabled_by_service}]">
      <span id="pvr_service_help_popup" class="help_popup" style="display: none;" >{{getPvrInlineText(serviceData.pvr_lifetime_in_days, serviceData.pvr_disabled_by_service)}}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'pvr_limit_service', {disabled: !serviceData.pvr_free_minutes && !serviceData.pvr_lifetime_in_days}, {forbidden: serviceData.pvr_disabled_by_service}]">
      <span class="service_values_item_value">{{ serviceData.pvr_disabled_by_service ? $gettext('Zakázáno') : getMinutesText(serviceData.pvr_free_minutes) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Volné minuty nahrávek
													</span>
    </div>
    <div
        v-if="inline && (serviceData.pvr_free_minutes || serviceData.pvr_lifetime_in_days || serviceData.pvr_disabled_by_service)"
        :class="['service_values_item', 'pvr_limit_service', {'disabled forbidden': serviceData.pvr_disabled_by_service}]">
      <span class="help_popup" style="display: none;">{{ getPvrLimitInlineText(serviceData.pvr_free_minutes, serviceData.pvr_disabled_by_service) }}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'per_records_service', {disabled: !serviceData.periodic_pvr_count}, {forbidden: serviceData.periodic_pvr_disabled_by_service}]">
      <span class="service_values_item_value">{{ serviceData.periodic_pvr_disabled_by_service ? $gettext('Zakázáno') : getRecordsText(serviceData.periodic_pvr_count) }}</span>
      <span class="help_popup" v-translate>
														Počet pravidelných nahrávek
													</span>
    </div>
    <div
        v-if="inline && (serviceData.periodic_pvr_count || serviceData.periodic_pvr_disabled_by_service)"
        :class="['service_values_item', 'per_records_service', {'disabled forbidden': serviceData.periodic_pvr_disabled_by_service}]">
      <span class="help_popup" style="display: none;">{{ getPeriodicPvrInlineText(serviceData.periodic_pvr_count, serviceData.periodic_pvr_disabled_by_service) }}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'per_records_days_service', {disabled: !serviceData.periodic_pvr_days_back}, {forbidden: serviceData.periodic_pvr_disabled_by_service}]"
         class="service_values_item per_records_days_service">
      <span class="service_values_item_value">{{ serviceData.periodic_pvr_disabled_by_service ? $gettext('Zakázáno') : getDaysText(serviceData.periodic_pvr_days_back) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Počet dní přehratelnosti pravidelných nahrávek po catchupu
													</span>
    </div>
    <div
        v-if="inline && (serviceData.periodic_pvr_days_back || serviceData.periodic_pvr_disabled_by_service)"
        :class="['service_values_item', 'per_records_days_service', {'disabled forbidden': serviceData.periodic_pvr_disabled_by_service}]">
      <span class="help_popup" style="display: none;">{{ getPeriodicPvrDaysInlineText(serviceData.periodic_pvr_days_back, serviceData.periodic_pvr_disabled_by_service) }}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'catchup_service', {disabled: !serviceData.catchup_hours}, {forbidden: serviceData.catchup_disabled_by_service}]">
													<span v-if="serviceData.catchup_hours" class="service_values_item_value">
														<span class="dotted"
                                  :title="$gettext('Pro konkrétní nastavení si zobrazte seznam kanálů.')">{{serviceData.catchup_disabled_by_service ? $gettext('Zakázáno') : this.getHoursText(serviceData.catchup_hours) }}</span>
													</span>
      <span v-else class="service_values_item_value">
														{{serviceData.catchup_disabled_by_service ? $gettext('Zakázáno') : this.getBooleanText(serviceData.catchup) }}
													</span>
      <span class="help_popup" style="display: none;" v-translate>
														Catchup
													</span>
    </div>
    <div
        v-if="inline && (serviceData.catchup_hours || serviceData.catchup_disabled_by_service)"
        :class="['service_values_item', 'catchup_service', {'disabled forbidden': serviceData.catchup_disabled_by_service}]">
      <span class="help_popup" style="display: none;">{{ getCatchupInlineText(serviceData.catchup_hours, serviceData.catchup_disabled_by_service) }}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'timeshift_service', {disabled: !serviceData.timeshift}, {forbidden: serviceData.timeshift_disabled_by_service}]">
      <span class="service_values_item_value">{{serviceData.timeshift_disabled_by_service ? $gettext('Zakázáno') :  getBooleanText(serviceData.timeshift) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Timeshift
													</span>
    </div>
    <div
        v-if="inline && (serviceData.timeshift || serviceData.timeshift_disabled_by_service)"
        :class="['service_values_item', 'timeshift_service', {'disabled forbidden': serviceData.timeshift_disabled_by_service}]">
      <span class="help_popup" style="display: none;">{{ getTimeshiftInlineText(serviceData.timeshift, serviceData.timeshift_disabled_by_service) }}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'devices_service', {disabled: !serviceData.device_count}]">
      <span class="service_values_item_value">{{ getDeviceText(serviceData.device_count, serviceData.device_addon) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Počet současně streamujících zařízení
													</span>
    </div>
    <div
        v-if="inline && serviceData.device_count"
        :class="['service_values_item', 'devices_service']">
      <span class="help_popup" style="display: none;">{{ getDeviceInlineText(serviceData.device_count, serviceData.device_addon,  serviceData.device_count_disabled_by_service) }}</span>
    </div>
    <div
        v-if="!inline"
        :class="['service_values_item', 'profiles_service', {disabled: !serviceData.subscriber_profile_count}]">
      <span class="service_values_item_value">{{ getSubscriberProfileText(serviceData.subscriber_profile_count, serviceData.subscriber_profile_addon) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Počet uživatelských profilů
													</span>
    </div>
    <div
        v-if="inline && serviceData.subscriber_profile_count"
        :class="['service_values_item', 'profiles_service']">
      <span class="help_popup" style="display: none;">{{ getSubscriberProfileInlineText(serviceData.subscriber_profile_count, serviceData.subscriber_profile_addon) }}</span>
    </div>
    <div
        v-if="!inline"
        :class="['service_values_item', 'fast_forward_service', {disabled: timeWithNoAdvertisementAfterStartSecondsDisabled}]">
      <span class="service_values_item_value">
              <span v-if="isFinalType">
														<a @click="onIndividualClick(
                                $gettext('Doba od začátku přehrávání, po kterou lze v reklamě přetáčet'),
                                {
                                'linear': serviceData.time_with_no_advertisement_after_start_seconds,
                                'nonlinear': serviceData.time_with_no_advertisement_after_start_seconds_nonlinear
                                },
                                'seconds'
														)" v-if="timeWithNoAdvertisementAfterStartSeconds['isIndividual']">{{ timeWithNoAdvertisementAfterStartSeconds['text'] }}</a>
                            <template v-else>{{ timeWithNoAdvertisementAfterStartSeconds['text'] }}</template>
													</span>
														<span v-else class="dotted"
                                  :title="$gettext('Živě, timeshift / catchup, PVR')">{{ getSecondsText(serviceData.time_with_no_advertisement_after_start_seconds) }} / {{ getSecondsText(serviceData.time_with_no_advertisement_after_start_seconds_nonlinear) }}</span>
													</span>
      <span class="help_popup" style="display: none;" v-translate>
														Doba od začátku přehrávání, po kterou lze v reklamě přetáčet
													</span>
    </div>
    <div
        v-if="inline && (serviceData.time_with_no_advertisement_after_start_seconds !== null || serviceData.time_with_no_advertisement_after_start_seconds_nonlinear !== null)"
        :class="['service_values_item', 'fast_forward_service']">
      <span class="help_popup" style="display: none;">{{ getTimeWithNoAdvertisementAfterStartInlineText(serviceData.time_with_no_advertisement_after_start_seconds, serviceData.time_with_no_advertisement_after_start_seconds_nonlinear) }}</span>
    </div>
    <div
        v-if="!inline"
        :class="['service_values_item', 'watching_ad_time_service', {disabled: skipAfterSecondsDisabled}]">
													<span class="service_values_item_value">
                                          <span v-if="isFinalType">
                                            <a v-if="skipAfterSeconds['isIndividual']"
                                               @click="onIndividualClick(
                                $gettext('Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením'),
                                {
                                'linear': serviceData.skip_after_seconds,
                                'nonlinear': serviceData.skip_after_seconds_nonlinear
                                },
                                'seconds'
														)">{{ skipAfterSeconds['text'] }}</a>
                                            <template v-else>{{ skipAfterSeconds['text'] }}</template>
													</span>
														<span v-else class="dotted" :title="$gettext('Živě, timeshift / catchup, PVR')">{{
                                getSecondsText(serviceData.skip_after_seconds)
                              }} / {{ getSecondsText(serviceData.skip_after_seconds_nonlinear) }}</span>
													</span>
      <span class="help_popup" style="display: none;" v-translate>
														Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením
													</span>
    </div>
    <div
        v-if="inline && (serviceData.skip_after_seconds !== null || serviceData.skip_after_seconds_nonlinear !== null)"
        :class="['service_values_item', 'watching_ad_time_service']">
      <span class="help_popup" style="display: none;">{{ getWatchAdTimeInlineText(serviceData.skip_after_seconds, serviceData.skip_after_seconds_nonlinear) }}</span>
    </div>
    <div
        v-if="!inline"
        :class="['service_values_item', 'skip_ad_service', {disabled: allowSkipMultipleAdvertisementBlocksDisabled}]">
													<span class="service_values_item_value">
                                          <span v-if="isFinalType">
                                            <a v-if="allowSkipMultipleAdvertisementBlocks['isIndividual']"
                                               @click="onIndividualClick(
                                $gettext('Přeskakování více reklamních bloků'),
                                {
                                'linear': serviceData.allow_skip_multiple_advertisement_blocks,
                                'nonlinear': serviceData.allow_skip_multiple_advertisement_blocks_nonlinear
                                },
                                'boolean'
														)">{{ allowSkipMultipleAdvertisementBlocks['text'] }}</a>
                                            <template v-else>{{ allowSkipMultipleAdvertisementBlocks['text'] }}</template>
													</span>
														<span v-else class="dotted" :title="$gettext('Živě, timeshift / catchup, PVR')">{{
                                getBooleanText(serviceData.allow_skip_multiple_advertisement_blocks)
                              }} / {{
                                getBooleanText(serviceData.allow_skip_multiple_advertisement_blocks_nonlinear)
                              }}</span>
													</span>
      <span class="help_popup" style="display: none;" v-translate>
														Přeskakování více reklamních bloků
													</span>
    </div>
    <div
        v-if="inline && (serviceData.allow_skip_multiple_advertisement_blocks || serviceData.allow_skip_multiple_advertisement_blocks_nonlinear)"
        :class="['service_values_item', 'skip_ad_service']">
      <span class="help_popup" style="display: none;">{{ getSkipMultiAdInlineText(serviceData.allow_skip_multiple_advertisement_blocks, serviceData.allow_skip_multiple_advertisement_blocks_nonlinear) }}</span>
    </div>

    <div
        v-if="!inline"
        :class="['service_values_item', 'skip_ad_service', {disabled: autoskipDisabled}]">
                    <span v-if="isFinalType" class="service_values_item_value">
                      <a v-if="autoskip['isIndividual']"
                         @click="onIndividualClick(
                                $gettext('Automatické přeskakování reklam'),
                                {
                                'value': serviceData.autoskip,
                                },
                                'boolean'
														)">{{ autoskip['text'] }}</a>
                      <template v-else>{{ autoskip['text'] }}</template>
													</span>
      <span v-else class="service_values_item_value">{{ getBooleanText(serviceData.autoskip) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Automatické přeskakování reklam
													</span>
    </div>
    <div
        v-if="inline && serviceData.autoskip"
        :class="['service_values_item', 'skip_ad_service', {forbidden: serviceData.autoskip_disabled_by_service}]">
      <span class="help_popup" style="display: none;">{{ getAutoskipInlineText(serviceData.autoskip) }}</span>
    </div>

    <!--vod -->
    <div
        v-if="!inline"
        :class="['service_values_item', 'vod_service', {disabled: !isVodAvailable}, {forbidden: serviceData.vod_disabled_by_service}]">
      <span class="service_values_item_value">{{ serviceData.vod_disabled_by_service ? $gettext('Zakázáno') :getAllowedText(isVodAvailable) }}</span>
      <span class="help_popup" style="display: none;" v-translate>
        Filmotéka
        <template v-for="(packages, provider) in serviceData.vod">
            <span>{{provider}}</span> {{packages.join(', ')}}
        </template>
      </span>
    </div>
    <div
        v-if="inline && (isVodAvailable || serviceData.vod_disabled_by_service)"
        :class="['service_values_item', 'vod_service', {'disabled forbidden':serviceData.vod_disabled_by_service}]">
      <span v-if="serviceData.vod_disabled_by_service" class="help_popup" style="display: none;" v-translate>Filmotéka: Zakázáno</span>
      <span v-else class="help_popup" style="display: none;" v-translate>{{$gettext('Filmotéka')}}
      <template v-for="(packages, provider) in serviceData.vod">
            <span>{{provider}}</span> {{packages.join(', ')}}
        </template></span>
    </div>

    <!-- channelsCount -->
    <div
        v-if="!inline"
        :class="['service_values_item', 'channel_list_service', {disabled: !channelsCount}]">
      <span class="service_values_item_value" v-if="channelsCount"><a @click="onChannelListClick">{{ getChannelText(channelsCount) }}</a></span>
      <span class="service_values_item_value" v-else v-translate>Žádné kanály</span>
      <span class="help_popup" style="display: none;" v-translate>
														Seznam kanálů
													</span>
    </div>
    <div
        v-if="inline && channelsCount"
        :class="['service_values_item', 'channel_list_service']">
      <span class="help_popup" style="display: none;">{{ getChannelInlineText(channelsCount) }}</span>
    </div>

    <!-- weight -->
    <div v-if="!isFinalType && !inline" class="service_values_item weight_service">
      <span class="service_values_item_value">{{ serviceData.weight }}</span>
      <span class="help_popup" style="display: none;" v-translate>
														Váha
													</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "ServiceIcons",
  components: {},
  props: {
    serviceType: String,
    serviceData: Object,
    inline: Boolean,
  },
  mounted() {
    var showTimeout;
    $('.service_values_item').mouseenter(function() {
      var $popup = $(this).find('.help_popup');
      showTimeout = setTimeout(function() {
        $popup.show();
      }, 500);
    });

    $('.service_values_item').mouseleave(function() {
      var $popup = $(this).find('.help_popup');
      clearTimeout(showTimeout);
      $popup.hide();
    });
  },
  computed: {
    isFinalType() {
      return this.serviceType === 'final';
    },
    channelsCount() {
      return this.serviceData.channels ? this.serviceData.channels.length : 0;
    },
    isVodAvailable() {
      return Object.keys(this.serviceData.vod).length > 0;
    },
    timeWithNoAdvertisementAfterStartSeconds() {
      const result = [];
      const linear = this.isIndividual(this.serviceData.time_with_no_advertisement_after_start_seconds);
      const nonlinear = this.isIndividual(this.serviceData.time_with_no_advertisement_after_start_seconds_nonlinear);
      if (linear || nonlinear) {
        result['isIndividual'] = true;
        result['text'] = this.$gettext('Individuální');
        result['isDisabled'] = false;
      } else {
        const linearText = linear === false ? this.getSecondsText(this.serviceData.time_with_no_advertisement_after_start_seconds['all']) : '–';
        const nonlinearText = nonlinear === false ? this.getSecondsText(this.serviceData.time_with_no_advertisement_after_start_seconds_nonlinear['all']) : '–';
        result['isIndividual'] = false;
        result['text'] = linearText + " / " + nonlinearText;
        result['isDisabled'] = (linear !== false && nonlinear !== false);
      }

      return result;
    },
    timeWithNoAdvertisementAfterStartSecondsDisabled(){
      if(this.isFinalType){
        return this.timeWithNoAdvertisementAfterStartSeconds['isDisabled'];
      }else{
        return this.serviceData.time_with_no_advertisement_after_start_seconds === null && this.serviceData.time_with_no_advertisement_after_start_seconds_nonlinear === null
      }
    },
    skipAfterSeconds() {
      const result = [];
      const linear = this.isIndividual(this.serviceData.skip_after_seconds);
      const nonlinear = this.isIndividual(this.serviceData.skip_after_seconds_nonlinear);
      if (linear || nonlinear) {
        result['isIndividual'] = true;
        result['text'] = this.$gettext('Individuální');
        result['isDisabled'] = false;
      } else {
        const linearText = linear === false ? this.getSecondsText(this.serviceData.skip_after_seconds['all']) : '–';
        const nonlinearText = nonlinear === false ? this.getSecondsText(this.serviceData.skip_after_seconds_nonlinear['all']) : '–';
        result['isIndividual'] = false;
        result['text'] = linearText + " / " + nonlinearText;
        result['isDisabled'] = (linear !== false && nonlinear !== false);
      }

      return result;
    },
    skipAfterSecondsDisabled(){
      if(this.isFinalType){
        return this.skipAfterSeconds['isDisabled'];
      }else{
        return this.serviceData.skip_after_seconds === null && this.serviceData.skip_after_seconds_nonlinear === null
      }
    },
    allowSkipMultipleAdvertisementBlocks() {
      const result = [];
      const linear = this.isIndividual(this.serviceData.allow_skip_multiple_advertisement_blocks);
      const nonlinear = this.isIndividual(this.serviceData.allow_skip_multiple_advertisement_blocks_nonlinear);
      if (linear || nonlinear) {
        result['isIndividual'] = true;
        result['text'] = this.$gettext('Individuální');
        result['isDisabled'] = false;
      } else {
        const linearText = linear === false ? this.getBooleanText(this.serviceData.allow_skip_multiple_advertisement_blocks['all']) : '–';
        const nonlinearText = nonlinear === false ? this.getBooleanText(this.serviceData.allow_skip_multiple_advertisement_blocks_nonlinear['all']) : '–';
        result['isIndividual'] = false;
        result['text'] = linearText + " / " + nonlinearText;
        result['isDisabled'] = (linear !== false && nonlinear !== false);
      }
      return result;
    },
    allowSkipMultipleAdvertisementBlocksDisabled(){
      if(this.isFinalType){
        return this.allowSkipMultipleAdvertisementBlocks['isDisabled'];
      }else{
        return this.serviceData.allow_skip_multiple_advertisement_blocks === null && this.serviceData.allow_skip_multiple_advertisement_blocks_nonlinear === null
      }
    },
    autoskip() {
      const result = [];
      const autoskip = this.isIndividual(this.serviceData.autoskip);
      if (autoskip) {
        result['isIndividual'] = true;
        result['text'] = this.$gettext('Individuální');
        result['isDisabled'] = false;
      } else {
        result['isIndividual'] = false;
        result['text'] = autoskip === false ? this.getBooleanText(this.serviceData.autoskip['all']) : '–';
        result['isDisabled'] = autoskip !== false;
      }

      return result;
    },
    autoskipDisabled(){
      if(this.isFinalType){
        return this.autoskip['isDisabled'];
      }else{
        return this.serviceData.autoskip === null;
      }
    },
  },
  methods: {
    isIndividual(data){
      if(data.hasOwnProperty('all')){
        return Object.keys(data).length > 1;
      }else{
        return Object.keys(data).length > 0 ? true : null;
      }
    },
    onIndividualClick(title, advertisingData, type){
      let data = {};
      data['title'] = title;
      data['data'] = advertisingData;
      data['type'] = type;
      this.$emit('showAdvertisementPopup', data);
    },
    onChannelListClick(){
      this.$emit('showChannels');
    },
    getSecondsText(value) {
      if (value !== null) {
        if (value < 1){
          return value + ' ' + this.$gettext("vteřin");
        } else if (value < 2) {
          return value + ' ' + this.$gettext("vteřina");
        } else if (value < 5) {
          return value + ' ' + this.$gettext("vteřiny");
        } else {
          return value + ' ' + this.$gettext("vteřin");
        }
      } else {
        return '–';
      }
    },
    getMinutesText(value) {
      if (value) {
        if (value < 2) {
          return value + ' ' + this.$gettext("minuta");
        } else if (value < 5) {
          return value + ' ' + this.$gettext("minuty");
        } else {
          return value + ' ' + this.$gettext("minut");
        }
      } else {
        return '–';
      }
    },
    getHoursText(value) {
      if (value) {
        if (value < 2) {
          return value + ' ' + this.$gettext("hodina");
        } else if (value < 5) {
          return value + ' ' + this.$gettext("hodiny");
        } else {
          return value + ' ' + this.$gettext("hodin");
        }
      } else {
        return '–';
      }
    },
    getDaysText(value) {
      if (value) {
        if (value < 2) {
          return value + ' ' + this.$gettext("den");
        } else if (value < 5) {
          return value + ' ' + this.$gettext("dny");
        } else {
          return value + ' ' + this.$gettext("dní");
        }
      } else {
        return '–';
      }
    },
    getChannelText(value) {
      if (value) {
        if (value < 2) {
          return value + ' ' + this.$gettext("kanál");
        } else if (value < 5) {
          return value + ' ' + this.$gettext("kanály");
        } else {
          return value + ' ' + this.$gettext("kanálů");
        }
      } else {
        return '–';
      }
    },
    getRecordsText(value, isAddon) {
      if (value) {
        let result = '';
        if (value < 2) {
          result = value + ' ' + this.$gettext("nahrávka");
        } else if (value < 5) {
          result = value + ' ' + this.$gettext("nahrávky");
        } else {
          result = value + ' ' + this.$gettext("nahrávek");
        }

        if(isAddon){
          result = '+'+result;
        }

        return result;
      } else {
        return '–';
      }
    },
    getDeviceText(value, isAddon) {
      if (value) {
        let result = value + ' ' + this.$gettext("zařízení");
        if(isAddon){
          result = '+'+result;
        }
        return result;
      } else {
        return '–';
      }
    },
    getSubscriberProfileText(value, isAddon) {
      if (value) {
        let result = "";
        if(value < 2) {
          result = value + ' ' + this.$gettext("uživatelský profil");
        }else if (value < 5) {
          result = value + ' ' + this.$gettext("uživatelské profily");
        }else{
          result = value + ' ' + this.$gettext("uživatelských profilů");
        }
        if(isAddon){
          result = '+'+result;
        }
        return result;
      } else {
        return '–';
      }
    },
    getBooleanText(value) {
      if (value === true) {
        return this.$gettext("Ano");
      } else if(value === false) {
        return this.$gettext("Ne");
      } else {
        return "–";
      }
    },
    getAllowedText(value) {
      if (value) {
        return this.$gettext("Povoleno");
      } else {
        return "–";
      }
    },
    getPvrInlineText(value, forbidden){
      return this.$gettext('Expirace nahrávek')+ ': '+(forbidden ? this.$gettext('Zakázáno') : this.getDaysText(value));
    },
    getPvrLimitInlineText(value, forbidden) {
      return this.$gettext('Volné minuty nahrávek') + ': ' +(forbidden ? this.$gettext('Zakázáno') : this.getMinutesText(value));
    },
    getPeriodicPvrInlineText(value, forbidden) {
      return this.$gettext('Počet pravidelných nahrávek') + ': ' +(forbidden ? this.$gettext('Zakázáno') : this.getRecordsText(value));
    },
    getPeriodicPvrDaysInlineText(value, forbidden) {
      return this.$gettext('Počet dní přehratelnosti pravidelných nahrávek po catchupu') + ': ' +(forbidden ? this.$gettext('Zakázáno') : this.getDaysText(value));
    },
    getCatchupInlineText(hours, forbidden) {
      return this.$gettext('Catchup') + ': ' +(forbidden ? this.$gettext('Zakázáno') : this.getHoursText(hours));
    },
    getTimeshiftInlineText(value, forbidden) {
      return this.$gettext('Timeshift') + ': ' +(forbidden ? this.$gettext('Zakázáno') : this.getBooleanText(value));
    },
    getDeviceInlineText(value, isAddon, ) {
      return this.$gettext('Zařízení') + ': '+ this.getDeviceText(value,isAddon);
    },
    getSubscriberProfileInlineText(value, isAddon) {
      return this.$gettext('Profily uživatele') + ': '+ this.getSubscriberProfileText(value, isAddon);
    },
    getTimeWithNoAdvertisementAfterStartInlineText(value, valueNonlinear) {
      return this.$gettext('Doba od začátku přehrávání, po kterou lze v reklamě přetáčet') + ': ' + this.getSecondsText(value) + ' / '+this.getSecondsText(valueNonlinear);
    },
    getWatchAdTimeInlineText(value, valueNonlinear) {
      return this.$gettext('Počet vteřin reklamního bloku, které je nutné sledovat před přeskočením') + ': ' + this.getSecondsText(value) + ' / '+this.getSecondsText(valueNonlinear);
    },
    getSkipMultiAdInlineText(value, valueNonlinear) {
      return this.$gettext('Přeskakování více reklamních bloků') + ': ' + this.getBooleanText(value) + ' / '+this.getBooleanText(valueNonlinear)
    },
    getAutoskipInlineText(value) {
      return this.$gettext('Automatické přeskakování reklam') + ': ' + this.getBooleanText(value);
    },
    getChannelInlineText(value) {
      return value ? this.$gettext('Počet kanálů') + ': ' + this.getChannelText(value) : this.$gettext('Žádné kanály');
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/servicesList/ServicesIcons.vue